import { Box, IconButton, Modal, Typography } from '@mui/material';
import React from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import { animations } from '../animations';
const style = {
  position: 'absolute',
  minHeight: '80vh',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center'
};

export const CustomModal = (props) => {
  const { children, title="", open, onClose } = props
  return (
    <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        {...props}
      >
      <Box sx={style} className={animations.fadeIn}>
        <IconButton color="primary" onClick={onClose} sx={{
          position: 'fixed',
          top: 20,
          right: 20
        }}><CancelIcon /></IconButton>
        <Typography variant="h3" color="primary">{title}</Typography>
        { children }
      </Box>
    </Modal>
  )
}
